import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ReportAddItemsDialog from "../service/reports/report-add-items-dialog";
import { itemListsApi } from "../../../api/item_lists";
import { normalizeError } from "../../../operationFeedback/normalizeError";

// Keep main's table editor; adapt only persistence to the item-list API.
export function ItemListBulkDialog({ listId, onClose, onSaved, onComplete }) {
  const { t } = useTranslation();
  const [state, setState] = useState({});
  const confirmed = useRef(new Set());
  const guard = useRef(false);
  const save = async (items, rowIds) => {
    if (guard.current || state.unknown) return false;
    guard.current = true;
    setState({ busy: true, total: items.length, count: confirmed.current.size });
    try {
      for (let index = 0; index < items.length; index += 1) {
        if (confirmed.current.has(rowIds[index])) continue;
        const item = items[index];
        const response = await itemListsApi.addItemToList(listId, {
          product_id: item.product_id,
          title: item.title || item.description,
          description: item.description || "",
          quantity: item.quantity,
          sales_price: item.sales_price,
          purchase_price: item.purchase_price,
          discount: item.discount,
          surcharge: item.surcharge,
        });
        if (!response.data?.success || !response.data?.data?.id) throw new Error("Unconfirmed item save");
        confirmed.current.add(rowIds[index]);
        setState({ busy: true, total: items.length, count: confirmed.current.size });
        onSaved(response.data.data);
      }
    } catch (error) {
      const normalized = normalizeError(error);
      const rejected = normalized.httpStatus >= 400 && normalized.httpStatus < 500;
      setState({ count: confirmed.current.size, total: items.length,
        unknown: !rejected || normalized.httpStatus === 409,
        error: rejected ? normalized.safeMessage || t("itemListDetail.save_failed") : t("itemListDetail.unknown"),
      });
      return false;
    } finally { guard.current = false; }
    onComplete(confirmed.current.size);
    return true;
  };
  return <ReportAddItemsDialog open onClose={onClose} onSave={save}
    saveState={{ ...state, confirmedIds: [...confirmed.current] }}
    saveFeedback={<>
      {(state.busy || state.count > 0) && <p role="status" className="mt-4 text-sm text-blue-700">{t("itemListDetail.progress", { count: state.count, total: state.total })}</p>}
      {state.error && <p role="alert" className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-800">{state.error}</p>}
    </>}
  />;
}
